import React, { Component } from 'react';
import { Route } from 'react-router-dom';
// import IdleTimer from 'react-idle-timer';
import { withTranslation } from 'react-i18next';
import AdviserDashboard from './AdviserDashboard';
import TotalMembersComponent from './TotalMembersComponent';
import MemberSite from './MemberSite';
import CommissionDetails from './CommissionDetails';


import '../css/AdviserPortal.css';
import './i18n';
import FeeBreakdown from './FeeBreakdown';

class AdviserPortal extends Component {
  constructor(props) {
    super(props)
    this.idleTimer = null
    this.state = { loading: true }
  }

  componentDidMount() {
    this.props.startLoadingAdvisers()
    this.props.startLoadingFeeSummary()
    // .then(() => {
    //   this.setState({ loading: false });
    // });
    // let adviserId = null
    // if(this.props.advisers && this.props.advisers.length!==0){
    //   adviserId = this.props.advisers.map(adviser => adviser.adviserId)
    //   this.props.startLoadingMembers(adviserId).then(() => this.setState({loading: false}))
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loading && this.props.advisers && this.props.fees) {
      this.setState({ loading: false })
    }
  }



  render() {
    const { t } = this.props;
    if (this.props.advisers && this.props.fees && this.props.advisers.length !== 0 && !this.state.loading) {
      const id = !this.props.selectedAdviserId ? this.props.advisers.map(adviser => adviser.adviserId) : this.props.selectedAdviserId;
      const commissionPayments = this.props.advisers.map(adviser => adviser.commission);
      return (
        <div className="adviserPortal">
          <Route exact path="/adv/login" render={() =>
            <AdviserDashboard {...this.props} />
          } />

          <Route exact path="/adv/totalMembers" render={() =>
            <AdviserDashboard id={id} {...this.props} />
          } />

          <Route path="/adv/totalMembers/:product" render={(params) =>
            <AdviserDashboard id={id} {...this.props} {...params} />
          } />

          <Route exact path="/adv/commissionPayment" render={() =>
            <AdviserDashboard id={id}
              commissionPayments={commissionPayments} {...this.props} />} />

          <Route exact path="/adv/feeBreakdown" render={() =>
            <FeeBreakdown commissionPayments={commissionPayments} />}>

          </Route>

          <Route path="/adv/memberSite/:usrMemberSetId/:menu/:tab" render={(params) =>
            <MemberSite {...this.props} {...params} />} />

          <Route path="/adv/commissionPayment/:date" render={(params) =>
            <CommissionDetails commissionPayments={commissionPayments} {...this.props} {...params} />} />

          {/* <Route path="/adv/totalContributorsNonContributors" render={() => 
            <TotalContributorsComponent {...this.props}/>}/> */}
        </div>
      )
    }
    else {
      return (
        <div className="adviserPortal">{t('adviserHomePage:preparing')}</div>
      )
    }
  }
}

export default withTranslation()(AdviserPortal);